// Mock data for Gujarat Mobile Landing Page

export const heroImages = [
  "https://images.unsplash.com/photo-1697545806245-9795b6056141",
  "https://images.pexels.com/photos/28919439/pexels-photo-28919439.jpeg",
  "https://images.unsplash.com/photo-1764795850248-97a5e986b242"
];

export const featuredProducts = [
  {
    id: 1,
    name: "iPhone 15 Pro",
    image: "https://images.unsplash.com/photo-1604671368394-2240d0b1bb6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxzbWFydHBob25lc3xlbnwwfHx8fDE3NzAxMDQzNjl8MA&ixlib=rb-4.1.0&q=85",
    badge: "Latest"
  },
  {
    id: 2,
    name: "Samsung Galaxy S24 Ultra",
    image: "https://images.unsplash.com/photo-1583573636246-18cb2246697f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxzbWFydHBob25lc3xlbnwwfHx8fDE3NzAxMDQzNjl8MA&ixlib=rb-4.1.0&q=85",
    badge: "Best Seller"
  },
  {
    id: 3,
    name: "Vivo V30 Pro",
    image: "https://images.unsplash.com/photo-1737717926731-4c861d0aac9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxmbGFnc2hpcCUyMHBob25lc3xlbnwwfHx8fDE3NzAxMDQzNzR8MA&ixlib=rb-4.1.0&q=85",
    badge: "Best Value"
  },
  {
    id: 4,
    name: "Oppo Reno 12 Pro",
    image: "https://images.unsplash.com/photo-1713470599405-3ca0ae1363f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxmbGFnc2hpcCUyMHBob25lc3xlbnwwfHx8fDE3NzAxMDQzNzR8MA&ixlib=rb-4.1.0&q=85",
    badge: "Hot Deal"
  },
  {
    id: 5,
    name: "Xiaomi 14",
    image: "https://images.unsplash.com/photo-1672413514634-4781b15fd89e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lc3xlbnwwfHx8fDE3NzAxMDQzNjl8MA&ixlib=rb-4.1.0&q=85",
    badge: "New Arrival"
  },
  {
    id: 6,
    name: "Realme GT 6",
    image: "https://images.pexels.com/photos/11216260/pexels-photo-11216260.jpeg",
    badge: "Budget Best"
  }
];

export const brands = [
  { name: "Samsung", logo: "/brands/samsung.svg" },
  { name: "Apple", logo: "/brands/apple.png" },
  { name: "Xiaomi", logo: "/brands/xiaomi.svg" },
  { name: "Vivo", logo: "/brands/vivo.svg" },
  { name: "Oppo", logo: "/brands/oppo.svg" },
  { name: "Realme", logo: "/brands/realme.svg" }
];

export const accessories = [
  {
    id: 1,
    name: "Premium Phone Cases",
    image: "https://images.unsplash.com/photo-1535157412991-2ef801c1748b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxwaG9uZSUyMGNhc2VzfGVufDB8fHx8MTc3MDEwNDQxOXww&ixlib=rb-4.1.0&q=85",
    category: "Protection"
  },
  {
    id: 2,
    name: "Wireless Earbuds",
    image: "https://images.unsplash.com/photo-1578319439584-104c94d37305?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxlYXJwaG9uZXN8ZW58MHx8fHwxNzcwMTA0NDI4fDA&ixlib=rb-4.1.0&q=85",
    category: "Audio"
  },
  {
    id: 3,
    name: "Fast Chargers & Cables",
    image: "https://images.unsplash.com/photo-1573739022854-abceaeb585dc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjBhY2Nlc3Nvcmllc3xlbnwwfHx8fDE3NzAxMDQ0MDh8MA&ixlib=rb-4.1.0&q=85",
    category: "Charging"
  },
  {
    id: 4,
    name: "Smart Watches",
    image: "https://images.unsplash.com/photo-1566793474285-2decf0fc182a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxtb2JpbGUlMjBhY2Nlc3Nvcmllc3xlbnwwfHx8fDE3NzAxMDQ0MDh8MA&ixlib=rb-4.1.0&q=85",
    category: "Wearables"
  },
  {
    id: 5,
    name: "Power Banks",
    image: "https://images.unsplash.com/photo-1593055454503-531d165c2ed8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxwaG9uZSUyMGNhc2VzfGVufDB8fHx8MTc3MDEwNDQxOXww&ixlib=rb-4.1.0&q=85",
    category: "Power"
  }
];

export const features = [
  {
    title: "100% Original Products",
    description: "All phones come with manufacturer warranty and original accessories",
    icon: "ShieldCheck"
  },
  {
    title: "Best Prices in Gujarat",
    description: "Competitive pricing with regular offers and discounts",
    icon: "IndianRupee"
  },
  {
    title: "Easy EMI & Exchange",
    description: "Flexible payment options with attractive exchange offers",
    icon: "CreditCard"
  },
  {
    title: "Expert Support",
    description: "Professional staff and reliable after-sales service",
    icon: "Headphones"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Patel",
    location: "Ahmedabad",
    rating: 5,
    text: "Best mobile store in Gujarat! Got my iPhone at the best price with excellent customer service.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100"
  },
  {
    id: 2,
    name: "Priya Shah",
    location: "Surat",
    rating: 5,
    text: "Amazing experience! Staff was very helpful and explained all features. EMI process was smooth.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100"
  },
  {
    id: 3,
    name: "Mehul Desai",
    location: "Vadodara",
    rating: 5,
    text: "Trusted store with genuine products. Got great exchange value for my old phone!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100"
  }
];

export const storeInfo = {
  phone: "+15557730075",
  email: "info@gujratmobile.com",
  whatsapp: "+15557730075",
  hours: "Mon-Sat: 10:00 AM - 9:00 PM, Sun: 11:00 AM - 7:00 PM",
  address: "Gujarat Mobile Store, Multiple Locations Across Gujarat, Main Branch: MAHAGUJARAT SHOPPING CENTER, Lambe Hanuman RD, opp. SAGAR SOCIETY, Kapodra Patiya, Surat"
};
